



































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import _ from "lodash";
import { Location } from "vue-router";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import * as RouteNames from "@/employee/route-names";

@Component
export default class AccountTypeSubheader extends Vue {
  @Prop({ required: false })
  accountId: number;

  @Prop({ required: false })
  isPreenrollment: number;

  drivewealthStore = useDrivewealthStore();
  drivewealthWizardStore = useDrivewealthWizardStore();

  get displayAccountType (): boolean {
    return Boolean((this.isPreenrollment || this.accountId));
  }

  get accountTypeDisplayCopy (): string {
    if (!this.displayAccountType) {
      return "";
    }
    else if (this.isPreenrollment) {
      return this.drivewealthStore.getAccountManagementTypeTitle(this.drivewealthWizardStore.enrollmentAccountType);
    }

    return this.drivewealthStore.accountManagementTypeTitle(this.accountId);
  }

  get displayLearnMoreButton (): boolean {
    return this.$route.name !== RouteNames.DrivewealthLearnMorePages;
  }

  get hasMultipleAccounts (): boolean {
      return this.drivewealthStore.accountSummariesV2 && this.drivewealthStore.accountSummariesV2.length > 1;
  }

  get accountSummariesLoaded (): boolean {
      return this.drivewealthStore.accountSummariesV2Loaded;
  }

  get learnMoreLocation (): Location {
    return {
      name: RouteNames.DrivewealthLearnMorePages,
      params: {
        subpage: "list"
      }
    };
  }
}
